<template>
  <div class="hero-body">
    <div class="container has-text-centered">
      <h1 class="title">{{ welcome.header }}</h1>
      <article class="message">
        <div class="message-body" v-html="welcome.message"></div>
      </article>
      <div
        v-if="showUserTokenExpiredMessage"
        v-html="userTokenExpiredMessage"
      ></div>
      <br v-if="showUserTokenExpiredMessage" />
      <a
        @click="newAppointment()"
        v-if="keyword"
        class="button is-primary is-large mb2"
        :disabled="buttonDisabled"
      >
        <span @click="newAppointment()">
          <i :class="['icon', startButton.icon]"></i>
          <span @click="newAppointment()">{{ startButton.text }}</span>
        </span>
      </a>
      <contact></contact>
    </div>
  </div>
</template>

<script>
import contact from "@/components/Contact";
import PatientQueuesService from "../services/PatientQueuesService";
import _ from "lodash";

export default {
  name: "home",

  components: {
    contact
  },

  data() {
    return {
      loading: false,
      showUserTokenExpiredMessage: false,
      buttonDisabled: false
    };
  },

  computed: {
    keyword() {
      return this.$route.params.keyword;
    },
    practice() {
      return this.$store.state.practice;
    },
    welcome() {
      return this.$store.getters["interview/welcome"];
    },
    userTokenExpiredMessage() {
      return this.$store.getters["interview/userTokenExpiredMessage"];
    },
    interviewId() {
      return this.$store.state.interview.id;
    },
    startButton() {
      return this.$store.getters["interview/startButton"];
    }
  },

  mounted() {},

  methods: {
    newAppointment() {
      if (this.loading === false) {
        this.loading = true;
        PatientQueuesService.create(
          this.interviewId,
          this.$route.query.user_token
        )
          .then(patientQueueId => {
            let params = {
              keyword: this.$route.params.keyword,
              p: 0,
              q: 0,
              id: patientQueueId
            };
            this.$router.push({
              name: "interview",
              params: params
            });
            this.$store.dispatch("interview/firstQuestion");
          })
          .catch(err => {
            console.error(err);
            try {
              let reason = _.get(err, "response.data.errors[0].detail");
              if (reason == "User token has expired.") {
                this.showUserTokenExpiredMessage = true;
                this.buttonDisabled = true;
                this.loading = false;
              } else if (reason == "User token is required.") {
                this.showUserTokenExpiredMessage = true;
                this.buttonDisabled = true;
                this.loading = false;
              } else {
                this.$router.push({ name: "home" });
              }
            } catch (error) {
              console.error(error);
              this.$router.push({ name: "home" });
            }
          });
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped></style>
